// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73850b33","453":"ed3810f9","553":"604ad04e","977":"4b93f112"}[chunkId] + ".chunk.js";
};